export const iconSvg =
  '<svg width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">' +
  '<g clip-path="url(#clip0)"> <g clip-path="url(#clip1)"> <path fill-rule="evenodd" clip-rule="' +
  'evenodd" d="M24.3319 12.5506V0.397461H18.187L15.3173 5.54918H18.3939L9.47253 15.6354L14.5167 6' +
  '.16367H11.4401L14.9284 0.397461H6.99805V12.5506C6.99805 16.7092 10.296 20.1333 14.5581 20.6464V27.67' +
  '47C10.7056 27.8444 7.73047 28.8644 7.73047 30.114H23.5994C23.5994 28.8644 20.6263 27.8444 16.7739 27.6' +
  '747V20.6464C21.0339 20.1333 24.3319 16.7092 24.3319 12.5506Z" fill="#0B1F66"/> </g> </g> <defs> <clipP' +
  'ath id="clip0"> <rect width="30" height="30" fill="white" transform="translate(0 0.397461)"/> </clipPat' +
  'h> <clipPath id="clip1"> <rect width="17.5862" height="30" fill="white" transform="translate(7 0.397461)' +
  '"/> </clipPath> </defs> </svg>';
